<script lang="ts">
	import { t } from '@woltair/translations-package-fe'
	import { onMount } from 'svelte'
	import { HEAT_PUMP } from '$params/heat_pump'
	// WHAT NEEDS TO BE DONE BEFORE THIS COMPONENT IS READY:
	// FIND WAY TO PULL IMAGES FROM WOLTADVISOR
	// 1) find way to pull images from woltadvisor
	// 2) remove or add some attributes + their mapping depending and texts of whats decided by content/business

	export let title: string
	// export let width: number
	// export let device: 'PHOTOVOLTAICS' | 'HEAT_PUMP'
	export let packageLimit: number
	export let packages: {
		slugId: string
	}[]

	type Package = {
		brandName?: string
		catalogId?: string
		catalogTotalPrice?: number
		catalogUid?: string
		currencyCode?: string
		description?: string
		deviceSubtypeId?: string
		dynamicPrice?: number
		floorHeatingCop?: string | number
		floorHeatingPerformance?: string | number
		heatPumpSystem?: string
		heatPumpType?: string
		images?: any[]
		languageCode?: string
		maxHeatLoss?: string
		noiseLevel?: number
		organizationId?: string
		originCountry?: string
		radiatorHeatingCop?: number
		radiatorHeatingPerformance?: number
		slugId?: string
		supplierId?: string
		supplierName?: string
		title: string
		withWater?: boolean
	}

	type AttributeMapping = {
		[key: string]: {
			show?: boolean
			displayName?: string
			unit?: string
			valueMapping?: {
				[key: string]: string
			}
			hintMessage?: string
			order?: number
		}
	}

	let packageBoxes: {
		catalogPackages?: Package[]
		totalPackages?: number
	}

	const attributeMapping: AttributeMapping = {
		currencyCode: {
			displayName: t('web.dynamic_pages.components.attributes.currency'),
			valueMapping: {
				CZK: 'Kč',
				EUR: '€',
				PLN: 'zł'
			}
		},
		catalogTotalPrice: {
			displayName: t('web.dynamic_pages.components.attributes.price')
		},
		radiatorHeatingPerformance: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.radiatorHeatingPerformance'),
			unit: 'kW',
			hintMessage: t('web.dynamic_pages.components.attributes.radiatorHeatingPerformance'),
			order: 1
		},
		noiseLevel: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.noiseLevel'),
			unit: 'dB',
			hintMessage: t('web.dynamic_pages.components.attributes.noiseLevel'),
			order: 2
		},
		heatPumpSystem: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.heatPumpSystem'),
			valueMapping: {
				AIR_TO_WATER: t('web.dynamic_pages.components.attributes.heatPumpSystem.AIR_TO_WATER'),
				GROUND_TO_WATER: t(
					'web.dynamic_pages.components.attributes.heatPumpSystem.GROUND_TO_WATER'
				),
				AIR_TO_AIR: t('web.dynamic_pages.components.attributes.heatPumpSystem.AIR_TO_AIR'),
				WATER_TO_WATER: t('web.dynamic_pages.components.attributes.heatPumpSystem.WATER_TO_WATER')
			},
			hintMessage: t('web.dynamic_pages.components.attributes.heatPumpSystem'),
			order: 3
		},
		heatPumpType: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.heatPumpType'),
			valueMapping: {
				MONOBLOK: t('web.dynamic_pages.components.attributes.heatPumpType.MONOBLOK'),
				SPLIT: t('web.dynamic_pages.components.attributes.heatPumpType.SPLIT'),
				AIR_TO_AIR: t('web.dynamic_pages.components.attributes.heatPumpSystem.AIR_TO_AIR'),
				WATER_TO_WATER: t('web.dynamic_pages.components.attributes.heatPumpSystem.WATER_TO_WATER')
			},
			hintMessage: t('web.dynamic_pages.components.attributes.heatPumpType'),
			order: 4
		},
		originCountry: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.originCountry'),
			order: 5
		},
		withWater: {
			show: true,
			displayName: t('web.dynamic_pages.components.attributes.withWater'),
			order: 6
		}
	}

	onMount(async () => {
		const response = await fetch('/api/woltadvisor/get-packages', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				limit: packageLimit,
				...(packages?.length && { packages: packages.map((pkg) => pkg.slugId) })
			})
		})
		packageBoxes = await response.json()
	})

	function mapAttributes(packageBox: Package) {
		const mappedPackages = Object.entries(packageBox)
			.map(([key, value]) => {
				if (attributeMapping.hasOwnProperty(key) && attributeMapping[key].show === true) {
					return {
						...attributeMapping[key],
						key,
						value,
						...(typeof value === 'string' &&
							attributeMapping[key].valueMapping && {
								value: attributeMapping[key].valueMapping?.[value.toString()] || value
							})
					}
				}
			})
			.filter(Boolean)

		return mappedPackages.sort((a, b) => (a?.order || 0) - (b?.order || 1))
	}

	const prefexes = ['CZ', 'PL', 'DE', 'IT', 'TČ', 'FVE']

	function formatPackageTitle(title: string) {
		const prefix = title.substring(0, title.indexOf(' '))

		const formatted = prefexes.includes(prefix) ? title.replace(prefix, '') : title
		return formatted
	}
</script>

{#if title}
	<h2
		class="unstyled mb-10 mt-0 text-lg font-semibold leading-normal text-w-blue-950 md:text-2xl lg:text-2.5xl"
	>
		{title}
	</h2>
{/if}

<div class="grid w-full max-w-full grid-cols-1 gap-8 md:grid-cols-12">
	{#if packageBoxes?.catalogPackages}
		{#each packageBoxes?.catalogPackages as packageBox}
			<a
				href="/marketplace/{HEAT_PUMP}/{packageBox.slugId}"
				class="link flex max-w-full self-stretch @container md:col-span-6 xl:col-span-4"
			>
				<!-- marketplace/{packageBox.slugId} -->
				<div
					class="flex grid-cols-12 flex-col items-center gap-4 overflow-hidden rounded-3xl bg-neutral-100 @xs:min-h-[278px] @xs:flex-row"
				>
					<div
						class="flex flex-col gap-y-4 self-stretch p-8 py-10 pb-0 @xs:basis-[60%] @xs:pb-10 @xs:pr-0"
					>
						<h4
							class="unstyled text-base font-semibold text-neutral-900 transition-colors @lg:text-xl"
						>
							{formatPackageTitle(packageBox.title)}
						</h4>
						<div>
							<p class="attributes mb-4 flex flex-wrap gap-x-2 gap-y-2 text-xs">
								{#each mapAttributes(packageBox) as attribute}
									{#if attribute?.value}
										<span class="attribute whitespace-nowrap">
											{#if typeof attribute?.value === 'boolean'}
												{attribute?.displayName}
											{:else}
												{attribute?.value}{attribute?.unit ? ` ${attribute.unit}` : ''}
											{/if}

											{#if attribute.hintMessage}
												<span
													class="hint-wrapper relative ml-1 flex aspect-square h-full items-center justify-center rounded-full bg-w-red-500 text-[10px] text-white"
													>?
													<span
														class="hint pointer-events-none absolute -translate-y-6 rounded-sm bg-w-blue-950 px-2 py-1 opacity-0 transition-opacity duration-100"
														>{attribute.hintMessage}</span
													></span
												>
											{/if}</span
										>
									{/if}
								{/each}
							</p>
						</div>

						{#if packageBox.catalogTotalPrice && packageBox.currencyCode}
							<div class="@xs:mt-auto">
								<p class="text-base font-semibold @lg:text-xl">
									{Math.round(packageBox.catalogTotalPrice)
										.toString()
										.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
									{attributeMapping?.currencyCode?.valueMapping?.[packageBox?.currencyCode] ||
										packageBox?.currencyCode}
								</p>
								<p class="text-xs text-neutral-400">
									{t('web.dynamic_pages.components.inclPriceAndInstall')}
								</p>
							</div>
						{/if}
					</div>

					<div class="relative flex self-stretch overflow-hidden @xs:basis-[40%]">
						<img
							src={packageBox.images?.[0] || '/images/devices/heatpump-generic.webp'}
							alt={packageBox.title}
							class="h-full object-cover object-left py-4"
						/>
					</div>
				</div>
			</a>
		{/each}
	{:else}
		{#each { length: packageLimit } as _}
			<div
				class="flex min-h-[278px] w-full max-w-full self-stretch overflow-hidden rounded-3xl bg-neutral-100 @container md:col-span-6 xl:col-span-4"
			>
				<div class="flex w-2/3 animate-pulse flex-col p-8 py-10">
					<div class="h-5 w-11/12 rounded-lg bg-neutral-300" />
					<div class="mt-2 h-5 w-9/12 rounded-lg bg-neutral-300" />
					<div class="my-4 flex flex-wrap gap-x-3 gap-y-2">
						{#each { length: 4 } as _}
							<div class="mt-1 h-4 w-12 rounded-lg bg-neutral-300" />
						{/each}
					</div>
					<div class="mt-auto h-5 w-7/12 rounded-lg bg-neutral-300" />
					<div class="mt-2 h-4 w-9/12 rounded-lg bg-neutral-300" />
				</div>
				<div class="flex w-1/3 flex-col">
					<div class="my-8 h-full w-full animate-pulse rounded-l-3xl bg-neutral-300" />
				</div>
			</div>
		{/each}
	{/if}
</div>

<div>
	<a href="/" class="btn btn-new btn-new-blue mt-8">
		<!-- 
			RE-ENABLE WHEN WE HAVE WOLTADVISOR LOGIC FOR THIS COMPONENT DECIDED AND IMPLEMENTED
			{#if packageBoxes?.totalPackages && packageBoxes?.totalPackages > packageLimit}
			{t('web.dynamic_pages.components.showAllPackagesCounted', {
				count: packageBoxes.totalPackages.toString()
			})}
		{:else}
			{t('web.dynamic_pages.components.showAllPackages')}
		{/if} -->
		{t('web.dynamic_pages.components.showAllPackages')}
	</a>
</div>

<style lang="scss">
	.link:hover h4 {
		@apply text-w-red-500;
	}

	.attributes {
		.attribute {
			@apply flex items-center;
		}
		.attribute:not(:last-child)::after {
			@apply ml-2 mr-2 block aspect-square h-1
			rounded-full bg-neutral-300 content-[""];
		}
	}

	.hint-wrapper:hover .hint {
		@apply opacity-100;
	}
</style>
